module.exports = __webpack_public_path__ + "static/media/cash-withdrawal-icon.22b32f9d.svg";